import {
  IbackgroudPalette,
  IdefaultPalette,
  ItextPalette,
} from "../types/confilg";

export const ThemeConfig: any = (theme: {
  primary: IdefaultPalette;
  secondary: IdefaultPalette;
  background: IbackgroudPalette;
  text: ItextPalette;
}) => {
  return {
    light: {
      type: "light",
      mode: "light",
      primary: {
        main: theme.primary.main,
        dark: theme.primary.dark,
        light: theme.primary.light,
        contrastText: theme.primary.contrastText,
      },
      gray: {
        main: theme.background.default,
        dark: `var(--background-default-dark)`,
        light: `var(--background-default-light)`,
        contrastText: theme.background.default,
      },
      secondary: {
        main: theme.secondary.main,
        dark: theme.secondary.dark,
        light: theme.secondary.light,
        contrastText: theme.secondary.contrastText,
      },
      secondary1: {
        main: theme.secondary.main,
        dark: theme.secondary.dark,
        light: theme.secondary.light,
        contrastText: theme.secondary.contrastText,
      },
      secondary2: {
        main: `#3E6E78`,
        dark: `#354C57`,
        light: `#83ABA1`,
        contrastText: "#FFFFFF",
      },
      background: {
        paper: theme.background.paper,
        default: theme.background.default,
      },
      other: {
        customize1: "#D75A53",
        customize2: "#E46F4E",
        customize3: "#E58948",
        customize4: "#EA9F48",
        customize5: "#FFAB00",
        customize6: "#FF5530",
        customize7: "#5FC890",
        customize8: "#58B9A6",
        customize9: "#55B0AB",
        customize10: "#519AC2",
        customize11: "#3D5586",
        customize12: "#507EE1",
        customize13: "#006C9C",
        customize14: "#0F82E2",
        customize15: "#38B6C2",
        customize16: "#00B8D9",
        customize17: "#1515150D",
      },
      gradient: {
        gradient1: `linear-gradient(135deg, ${theme.primary.main} 0%, ${theme.primary.dark} 100%)`,
        gradient2: `linear-gradient(135deg, ${theme.primary.dark} 0%, ${theme.primary.light} 100%)`,
        gradient3: `linear-gradient(135deg, ${theme.primary.main} 0%, ${theme.primary.light} 100%)`,
        gradient4: `linear-gradient(135deg, #51854F 0%, ${theme.primary.main} 100%)`,
        gradient5: `linear-gradient(135deg, #51854F 0%, ${theme.primary.light} 100%)`,
        gradient6: `linear-gradient(135deg, ${theme.primary.main} 0%, ${theme.secondary.main} 100%)`,
        gradient7: `linear-gradient(131.03deg, rgba(79, 81, 88, 0.8) 0%, #3D4047 58.77%, #30333B 102.58%)`,
      },
      glassmorphism: {
        glassmorphism1: "rgba(255, 255, 255, 0.5)",
        glassmorphism2: "rgba(35, 39, 44, 0.8)",
        glassmorphism3:
          "linear-gradient(131.03deg, rgba(79, 81, 88, 0.64) 0%, rgba(61, 64, 71, 0.8) 58.77%, rgba(48, 51, 59, 0.8) 102.58%)",
      },
      error: { main: `#F44336`, dark: `#E31B0C`, light: `#F88078` },
      warning: { main: `#FF9800`, dark: `#C77700`, light: `#FFB547` },
      info: { main: `#2196F3`, dark: `#0B79D0`, light: `#64B6F7` },
      success: { main: `#4CAF50`, dark: `#3B873E`, light: `#7BC67E` },
      text: {
        primary: theme.text.primary,
        secondary: theme.text.secondary,
        disabled: theme.text.disabled,
      },
    },
    dark: {
      type: "dark",
      mode: "light",
      primary: {
        main: theme.primary.main,
        dark: theme.primary.dark,
        light: theme.primary.light,
        contrastText: theme.primary.contrastText,
      },
      gray: {
        main: `#202225`,
        dark: `#202225`,
        light: `#2f3136`,
        contrastText: "#37393f",
      },
      secondary1: {
        main: theme.secondary.main,
        dark: theme.secondary.dark,
        light: theme.secondary.light,
        contrastText: theme.secondary.contrastText,
      },
      secondary2: {
        main: `#3E6E78`,
        dark: `#354C57`,
        light: `#83ABA1`,
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: theme.secondary.main,
        dark: theme.secondary.dark,
        light: theme.secondary.light,
        contrastText: theme.secondary.contrastText,
      },
      background: {
        paper: theme.background.default,
        default: theme.background.paper,
      },
      other: {
        customize1: "#D75A53",
        customize2: "#E46F4E",
        customize3: "#E58948",
        customize4: "#EA9F48",
        customize5: "#FFAB00",
        customize6: "#FF5530",
        customize7: "#5FC890",
        customize8: "#58B9A6",
        customize9: "#55B0AB",
        customize10: "#519AC2",
        customize11: "#3D5586",
        customize12: "#507EE1",
        customize13: "#006C9C",
        customize14: "#0F82E2",
        customize15: "#38B6C2",
        customize16: "#00B8D9",
        customize17: "#1515150D",
      },
      gradient: {
        gradient1: `linear-gradient(135deg, ${theme.primary.main} 0%, ${theme.primary.dark} 100%)`,
        gradient2: `linear-gradient(135deg, ${theme.primary.dark} 0%, ${theme.primary.light} 100%)`,
        gradient3: `linear-gradient(135deg, ${theme.primary.main} 0%, ${theme.primary.light} 100%)`,
        gradient4: `linear-gradient(135deg, #51854F 0%, ${theme.primary.main} 100%)`,
        gradient5: `linear-gradient(135deg, #51854F 0%, ${theme.primary.light} 100%)`,
        gradient6: `linear-gradient(135deg, ${theme.primary.main} 0%, ${theme.secondary.main} 100%)`,
        gradient7: `linear-gradient(131.03deg, rgba(79, 81, 88, 0.8) 0%, #3D4047 58.77%, #30333B 102.58%)`,
      },
      glassmorphism: {
        glassmorphism1: "rgba(255, 255, 255, 0.5)",
        glassmorphism2: "rgba(35, 39, 44, 0.8)",
        glassmorphism3:
          "linear-gradient(131.03deg, rgba(79, 81, 88, 0.64) 0%, rgba(61, 64, 71, 0.8) 58.77%, rgba(48, 51, 59, 0.8) 102.58%)",
      },
      error: { main: `#F44336`, dark: `#E31B0C`, light: `#F88078` },
      warning: { main: `#FF9800`, dark: `#C77700`, light: `#FFB547` },
      info: { main: `#2196F3`, dark: `#0B79D0`, light: `#64B6F7` },
      success: { main: `#4CAF50`, dark: `#3B873E`, light: `#7BC67E` },
      text: {
        primary: theme.text.primary,
        secondary: theme.text.secondary,
        disabled: theme.text.disabled,
      },
    },
  };
};

export const defaultTheme = {
  mode: "light",
  primary: {
    main: `#00A64F`,
    dark: `#2B9746`,
    light: `#56C271`,
    contrastText: "#FFFFFF",
  },
  gray: {
    main: `#e3e5e8`,
    dark: `#d1d5d8`,
    light: `#2C2E33`,
    contrastText: "#F1F3F5",
  },
  secondary1: {
    main: `#151515`,
    dark: `#0B0B0B`,
    light: `#313131`,
    contrastText: "#FFFFFF",
  },
  secondary2: {
    main: `#3E6E78`,
    dark: `#354C57`,
    light: `#83ABA1`,
    contrastText: "#FFFFFF",
  },
  background: { paper: "#FFFFFF" },
  other: {
    customize1: "#D75A53",
    customize2: "#E46F4E",
    customize3: "#E58948",
    customize4: "#EA9F48",
    customize5: "#FFAB00",
    customize6: "#FF5530",
    customize7: "#5FC890",
    customize8: "#58B9A6",
    customize9: "#55B0AB",
    customize10: "#519AC2",
    customize11: "#3D5586",
    customize12: "#507EE1",
    customize13: "#006C9C",
    customize14: "#0F82E2",
    customize15: "#38B6C2",
    customize16: "#00B8D9",
    customize17: "#1515150D",
  },
  gradient: {
    gradient1: "linear-gradient(135deg, #B4CE56 0%, #899F4D 100%)",
    gradient2: "linear-gradient(135deg, #899F4D 0%, #D1D170 100%)",
    gradient3: "linear-gradient(135deg, #B4CE56 0%, #D1D170 100%)",
    gradient4: "linear-gradient(135deg, #51854F 0%, #B4CE56 100%)",
    gradient5: "linear-gradient(135deg, #51854F 0%, #D1D170 100%)",
    gradient6: "linear-gradient(135deg, #B4CE56 0%, #3E6E78 100%)",
    gradient7:
      "linear-gradient(131.03deg, rgba(79, 81, 88, 0.8) 0%, #3D4047 58.77%, #30333B 102.58%)",
  },
  glassmorphism: {
    glassmorphism1: "rgba(255, 255, 255, 0.5)",
    glassmorphism2: "rgba(35, 39, 44, 0.8)",
    glassmorphism3:
      "linear-gradient(131.03deg, rgba(79, 81, 88, 0.64) 0%, rgba(61, 64, 71, 0.8) 58.77%, rgba(48, 51, 59, 0.8) 102.58%)",
  },
  error: { main: `#F44336`, dark: `#E31B0C`, light: `#F88078` },
  warning: { main: `#FF9800`, dark: `#C77700`, light: `#FFB547` },
  info: { main: `#2196F3`, dark: `#0B79D0`, light: `#64B6F7` },
  success: { main: `#4CAF50`, dark: `#3B873E`, light: `#7BC67E` },
  text: {
    primary: `#030823`,
    secondary: `#8E8E8B`,
    disabled: `#D0D5CE`,
  },
};
